// extracted by mini-css-extract-plugin
export default {"collapseBtn":"Sidebar_collapseBtn__wB5uU"};